// extracted by mini-css-extract-plugin
var _1 = "container__SN7qX";
var _2 = "detailsRow__AX7Iq";
var _3 = "table-container__KwLt5";
var _4 = "text-cell__b9x2S";
var _5 = "top-panel__zla7D";
export { _1 as "container", _2 as "detailsRow", _3 as "tableContainer", _4 as "textCell", _5 as "topPanel" }
